import React, { Fragment, useEffect, useState } from "react";
import { Col, Card, CardHeader, CardBody, Form, FormGroup, Label, Row, InputGroup, Input } from 'reactstrap';
import { Btn, H3, Breadcrumbs } from "../../../AbstractElements";
import { useForm, Controller } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import { addCoupon, addNotificationChannel, editGetNotifcationChannel, getStatus, updateNotifcationChannel } from "../../../CommonURL";
import { getDataWithToken, postDataWithToken } from "../../../Utils/restUtils";
import SpinnerLoader from "../../../Layout/SpinnerLoader";
import DatePicker from 'react-datepicker';
import Typeahead from "../../../CommonElements/TypeAhead";
import { CouponName, Code, Type, Discount, StartDate, EndDate, UsersPerCoupon, UsersPerCustomer, SubmitForm, AddCoupon, Status, chnannelType, channelType, unitRate, charLimit } from '../../../Constant';
import '../../../Style/AdminStyle.scss';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import moment from 'moment';
import Transparentspinner from "../../Common/loader/Transparentspinner";
import { toast } from "react-toastify";

const schema = yup.object().shape({
    unitRate: yup.string().required().label('Code'),
    type: yup.mixed().required().label('Type'),
    CharLimit: yup.string().required().label('Discount'),
});

const AddEditChannel = () => {
    const { register, handleSubmit, control, formState: { errors }, setValue } = useForm({
        resolver: yupResolver(schema),
    });
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const searchParams = location.search;
    const params = new URLSearchParams(searchParams);
    const channelId = params.get("id");

    const navigate = useNavigate();

    const typeOptions = [
        { value: 'whatsapp', label: 'WhatsApp' },
        { value: 'sms', label: 'SMS' },
    ];

    const onSubmit = async (data) => {
        setLoading(true);
        const postRequest = {
            channel_type: data.type.value,
            unit_rate: data.unitRate,
            char_limit: data.CharLimit,
            ...(channelId && { channel_id: channelId })
        }
        const addPackageResponse = await postDataWithToken(channelId?updateNotifcationChannel:addNotificationChannel, postRequest);
        if (addPackageResponse.data.status === true) {
            toast.success(addPackageResponse.data.message);
            navigate(`${process.env.PUBLIC_URL}/configuration/notification-channel`);

        } else {
            toast.error(addPackageResponse.data.message);
        }
        setLoading(false);
    };

    const handleGetChannelDetails = async () => {
        setLoading(true)

        const response = await getDataWithToken(editGetNotifcationChannel + `?channel_id=${channelId}`)
        if (response?.status == true) {
            setValue('unitRate', response?.data?.unit_rate)
            setValue('CharLimit', response?.data?.char_limit)
            const chanelType = typeOptions?.find((item) => (item?.value == response?.data?.channel_type))
            setValue('type', chanelType)
        }
        setLoading(false)

    }


    useEffect(() => {
        if (channelId) {
            handleGetChannelDetails()

        }

    }, [channelId])
    return (
        <Fragment>
            {loading && (
                <Transparentspinner />
            )}

            <Breadcrumbs mainTitle='Notification Channel' parent="Configuration" title="Notification Channel" />
            <Card>
                <CardHeader className="pb-0">
                    <H3>
                        {
                            channelId?
                            "Edit Notification Channel"
                            :
                            "Add Notification Channel"
                            
                        }
                        </H3>
                </CardHeader>
                <CardBody>
                    <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                        <Row className="g-3">
                            <Col md='6'>
                                <Label className="form-label" >{channelType} <span className="requireStar">*</span></Label>
                                <Controller
                                    name="type"
                                    control={control}
                                    render={({ field }) => (
                                        <Typeahead
                                            options={typeOptions}
                                            onChange={(value) => {
                                                field.onChange(value);
                                            }}
                                            value={field.value}
                                        />
                                    )}
                                />
                                <p className="text-danger">{errors.type?.message}</p>
                            </Col>
                            <Col md='6'>
                                <Label className="form-label" for="name">{unitRate} <span className="requireStar">*</span></Label>
                                <input className="form-control" id="name" placeholder="Unit Rate" type="text" {...register('unitRate', { required: true })} />
                                <p className="text-danger">{errors.name?.message}</p>
                            </Col>
                            <Col md='6'>
                                <Label className="form-label" for="code">{charLimit} <span className="requireStar">*</span></Label>
                                <input className="form-control" id="code" type="text" placeholder="Char Limit" {...register('CharLimit', { required: true })} />
                                <p className="text-danger">{errors.code?.message}</p>
                            </Col>
                        </Row>
                        <FormGroup>
                        </FormGroup>
                        <Btn attrBtn={{ color: "primary" }} type="submit">{SubmitForm}</Btn>
                    </Form>
                </CardBody>
            </Card>
        </Fragment>
    )
}

export default AddEditChannel;
